module.exports = __webpack_public_path__ + "static/media/lease-up-logo.34ffc353.gif";